import { render, staticRenderFns } from "./AccesoDatos.vue?vue&type=template&id=d61b8d30"
import script from "./AccesoDatos.vue?vue&type=script&lang=js"
export * from "./AccesoDatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports